module.exports = __webpack_public_path__ + "img/learning-title.94619be2.png";